export default "__VITE_ASSET__0f341ea4__"